<!-- <app-navbar></app-navbar> -->
<!-- <app-documents></app-documents> -->
<!-- <main [@routeAnimations]="prepareRoute(outlet)"> -->
    <router-outlet #outlet="outlet"></router-outlet>  
<!-- </main> -->
